export const DIVISION_OPTIONS = [
  { value: 'DEP', label: 'Division of Educational Psychology (DEP)' },
  { value: 'DCoP', label: 'Division of Counselling Psychology (DCoP)' },
  { value: 'DCP', label: 'Division of Clinical Psychology (DCP)' },
  { value: 'DIOP', label: 'Division of Industrial and Organisational Psychology (DIOP)' },
  { value: 'HKICP', label: 'Hong Kong Institute of Clinical Psychologists (HKICP)' },
  { value: 'HKAEP', label: 'Hong Kong Association of Educational Psychologists (HKAEP)' },
  { value: 'HKPCA', label: 'Hong Kong Professional Counselling Association (HKPCA)' },
  { value: 'MCHK', label: 'Psychiatrist – Medical Council of Hong Kong Specialist Register (MCHK)' },
];
export const NUMBER_REQUIRED_ORGS = ['DEP', 'HKICP', 'HKAEP', 'HKPCA', 'MCHK'];
